import React, { useEffect, useRef, useState } from "react";
import Box from "@mui/material/Box";
import SalesByLocation from "./SalesByLocation";
import TransactionsByLocation from "./TransactionsByLocation";
import SalesInsightAreaHospitality from "./SalesInsightAreaHospitality";
import NetSalesAndTransactions from "./NetSalesAndTransactions";
import SalesByStaff from "./SalesByStaff";
import SalesByTender from "./SalesByTender";

const HospitalityBusinessDashboard = () => {
    const salesByTenderRef = useRef<HTMLDivElement>(null);
    const [salesByStaffHeight, setSalesByStaffHeight] = useState<number>(488);
    
    useEffect(() => {
        if (!salesByTenderRef.current) return undefined;

        const resize = () => (
            setSalesByStaffHeight(() => salesByTenderRef.current?.clientHeight || 488)
        )

        const observer = new ResizeObserver(resize)
        observer.observe(salesByTenderRef.current);

        return () => observer.disconnect();
    }, []);

    return (
                <Box sx={{ width: '100%', flexGrow: 1, height: 'auto'}}>
                    <Box>
                        <SalesInsightAreaHospitality/>
                    </Box>

                    <Box sx={{
                        display:'flex',
                        flexDirection:'row',
                        width:'auto',
                        justifyContent: 'space-between',
                    }}>
                        <Box sx={{width: '50%'}}>
                            <SalesByLocation/>
                        </Box>
                        <Box sx={{width: '50%'}}>
                            <TransactionsByLocation/>
                        </Box>
                    </Box>

                    <Box sx={{ marginY: '20px' }}>
                        <NetSalesAndTransactions/>
                    </Box>

                    <Box sx={{
                        marginY: '20px',
                        display:'flex',
                        flexDirection:'row',
                        alignItems: 'flex-start'
                    }}>
                        <Box sx={{
                            display: 'flex',
                            width: '33.33%',
                            height: salesByStaffHeight,
                            transition: 'height 500ms ease'
                        }}>
                            <SalesByStaff />
                        </Box>

                        <Box ref={salesByTenderRef} sx={{ width: '66.66%' }}>
                            <SalesByTender />
                        </Box>
                    </Box>
                </Box>
    );
};

export default HospitalityBusinessDashboard;
